// Context
import Modal from "../common/Modal";
import { useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import ModalProfileTermsOfUse from "../profile/ModalProfileTermsOfUse";
import { useTranslation } from "react-i18next";

function ModalSignTermsOfUse({ setShowSignTerm }) {
  const { t } = useTranslation();
  const { setAuth, auth } = useAuth();
  const [profile] = useState(auth.user);

  const setProfile = (profile) => {
    auth.user.custom = { ...auth.user.custom, ...profile.custom };
    setAuth({ ...auth });
    setShowSignTerm(false);
  };

  return (
    <Modal hideClose={true} show={true} size="full-screen" title={t("terms.acceptTitle")} className={"modal-terms-of-use"}>
      <ModalProfileTermsOfUse setProfile={setProfile} profile={profile}></ModalProfileTermsOfUse>
    </Modal>
  );
}

export default ModalSignTermsOfUse;
